import React from "react";
import Sidenav from "../components/Sidenav";
import Box from "@mui/material/Box";
import Navbar from "../components/Navbar";
import ChakraList from "../chakra/ChakraList";
import "../Dash.css";

export default function Chakra() {

  return (
    <>
      <div className="bgcolor">
        <Navbar />
        <Box height={70} />
        <Box sx={{ display: "flex" }}>
          <Sidenav />
          <Box component="main" sx={{ flexGrow: 1, p: 3 }}>
            <ChakraList />
          </Box>
        </Box>
      </div>
    </>
  );
}
